module.exports = __webpack_public_path__ + "static/media/20170501-DSC02542-6_Small.f7a491e9.jpg";